import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { User } from '@/types/user';
import * as api from '@/lib/api';

interface UserState {
  profile: User | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: UserState = {
  profile: null,
  isLoading: false,
  error: null,
};

export const fetchUser = createAsyncThunk('user/fetch', async (userId?: number | string) => {
  const userData = await api.getUser(userId);
  // Маппим данные из API в формат User
  return {
    id: userData.id || userData.Id,
    phone: userData.phone || userData.Phone,
    name: userData.name || userData.Name,
    lastName: userData.lastName || userData.LastName,
    birthdate: userData.birthdate || userData.Birthdate,
    avatar: userData.avatar || userData.Avatar,
    city: userData.city || userData.City,
    rating: userData.rating || userData.Rating,
  };
});

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setProfile: (state, action: PayloadAction<User | null>) => {
      state.profile = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.profile = action.payload;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Ошибка загрузки профиля';
      });
  },
});

export const { setProfile } = userSlice.actions;
export default userSlice.reducer;

